//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, Modal, View, Text, Linking, SafeAreaView, Platform, useWindowDimensions, FlatList } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useAccountContext } from '../../../hooks/useAccountContext';
import { createCommonStyles } from '../../../styles/commonStyles';
import { Checkbox } from 'react-native-paper';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomLabel from '../../../components/CustomLabel/CustomLabel';
import CustomButton from '../../../components/CustomButton';
import CustomCalendar from '../../../components/CustomCalendar/CustomCalendar';
import { showMessage } from "react-native-flash-message";
import { useTranslation } from 'react-i18next';
import { useTraining } from '../../../hooks/useTraining';
import { ActivityIndicator, Card } from 'react-native-paper';
import CustomDropDown from '../../../components/CustomDropDown/CustomDropdown';
import CustomInput from '../../../components/CustomInput';
import { useTableHelper } from '../../../hooks/useTableHelper';
import { formatDateForUI } from '../../../constants/FormatDate';
import Swal from 'sweetalert2';
import HRAdminAuthorizationForm from '../HRAdminEmployees/CreateEmployee/HRAdminAuthorizationForm';
import { ScrollView } from 'react-native-gesture-handler';
import * as XLSX from 'xlsx';
//#endregion

const ParticipantsListView = React.memo(({
    item,
    index,
    styles,
    common,
    participantOptions,
    handleEditPress,
    handleDelete,
    calendarSelectedDate,
    calendarVisible,
    openCalendar,
    onCalendarDateChange,
    equalCost
}) => {

    return (
        <Card key={item.rowguid} style={[common.cardstyle, { margin: 10 }]}>
            <Card.Content>
                <SafeAreaView style={{ flexDirection: "column" }}>
                    <SafeAreaView style={{ flexDirection: "row", flexWrap: 'nowrap', alignItems: 'center' }}>
                        {/* Participants Dropdown */}
                        <SafeAreaView style={styles.inputColumn}>
                            <CustomDropDown
                                type="EDIT_EMPLOYEE"
                                options={participantOptions}
                                setValue={(val) => handleEditPress(index, item, 'participants', val)}
                                value={item.participants}
                                defValue={item.participants}
                            />
                        </SafeAreaView>

                        {/* isAccepted Checkbox */}
                        <SafeAreaView style={styles.checkboxColumn}>
                            <Checkbox
                                status={item.isAccepted ? 'checked' : 'unchecked'}
                                onPress={() => handleEditPress(index, item, 'isAccepted', !item.isAccepted)}
                            />
                        </SafeAreaView>

                        {/* dateAwarded Date Input with calendar */}
                        <SafeAreaView style={styles.inputColumn}>
                            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                                <CustomInput
                                    value={formatDateForUI(item.doa)}
                                    setValue={() => { }}
                                    maxLen={50}
                                    editable={false}
                                    type="MAININPUT"
                                />
                                <Ionicons
                                    name={calendarVisible ? "calendar" : "calendar-outline"}
                                    style={styles.icons}
                                    onPress={openCalendar}
                                />
                            </View>

                        </SafeAreaView>

                        {/* isFacilitator Checkbox */}
                        <SafeAreaView style={styles.checkboxColumn}>
                            <Checkbox
                                status={item.isfacilitator ? 'checked' : 'unchecked'}
                                onPress={() => handleEditPress(index, item, 'isfacilitator', !item.isfacilitator)}
                            />
                        </SafeAreaView>

                        {/* firstEvaluation Checkbox */}
                        <SafeAreaView style={styles.checkboxColumn}>
                            <Checkbox
                                status={item.firstEvaluation ? 'checked' : 'unchecked'}
                                onPress={(val) => handleEditPress(index, item, 'firstEvaluation', !item.firstEvaluation)}
                            />
                        </SafeAreaView>

                        {/* secondEvaluation Checkbox */}
                        <SafeAreaView style={styles.checkboxColumn}>
                            <Checkbox
                                status={item.secondEvaluation ? 'checked' : 'unchecked'}
                                onPress={() => handleEditPress(index, item, 'secondEvaluation', !item.secondEvaluation)}
                            />
                        </SafeAreaView>

                        {/* cost Input */}
                        <SafeAreaView style={[styles.lastColumn]}>
                            <CustomInput
                                editable={!equalCost}
                                value={item.cost}
                                setValue={(val) => handleEditPress(index, item, 'cost', val)}
                                type='MAININPUT'
                            />
                            <CustomButton
                                iconName='trash-outline'
                                onPress={() => {
                                    handleDelete(item, index, 'rowguid')
                                }}
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='2'
                                sz={25}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                    <SafeAreaView style={{ alignItems: 'center' }}>
                        {calendarVisible && (
                            <CustomCalendar
                                calendarType={'RangePicker'}
                                setRange={(range) => onCalendarDateChange(range.startDate)}
                                range={{ startDate: calendarSelectedDate, endDate: calendarSelectedDate }}
                                allowSingleDate={true}
                                startingYear={1950}
                            />
                        )}</SafeAreaView>
                </SafeAreaView>
            </Card.Content>
        </Card>
    );

})

const HRAdminTrainingParticipantsScreen = (props) => {
    //#region Const Definitions
    const ref = useRef(null);
    const { account } = useAccountContext();
    const { t, i18n } = useTranslation();
    const { width, height } = useWindowDimensions();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { colors } = useTheme();
    const { username } = useAuthContext();
    const common = createCommonStyles(colors);
    const styles = makeStyles(colors, width, height, isPlatformWeb);

    const { participantOptions, data, trainings, participantsTabData,
        totalPart, selectedTraining, setRefreshAfterSave, equalCost, isEdit
    } = props;
    const [isLoading, setIsLoading] = useState(false);
    const [originalPartData, setOriginalPartData] = useState([]);
    const [trnOptions, setTRNOptions] = useState([]);
    const [fromUI, setFromUI] = useState(null);
    const [employeeID, setEmployeeid] = useState('');

    /* Participant Data reated variables */
    const [participantsData, setParticipantsData] = useState(data);
    const [changes, setChanges] = useState({});
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([]);
    const [duplicates, setDuplicates] = useState([]);

    const { deleteParticipantsData, checkAuthParticipants, saveParticipantsData,
        copyParticipants, printParticipants, getEmployeeId } = useTraining(); // Get trainings data
    const { rowEdit, rowDelete, rowAdd, handleCancelChanges } = useTableHelper();

    /* Add Participants Modal state variables and open/close functions */
    const [modalVisible, setModalVisible] = useState(false);
    const [copyModalVisible, setCopyModalVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rules, setRules] = useState([]);

    // Function to open modal
    const openModal = () => {
        setModalVisible(true);
    };

    const openCopyModal = () => {
        setCopyModalVisible(true);
    };

    // Function to close modal
    const closeModal = useCallback(() => {
        setErrorMessage('');
        setModalVisible(false);
    }, []);

    const closeCopyModal = useCallback(() => {
        setErrorMessage('');
        setCopyModalVisible(false);
    }, []);

    /* Calendar Related state variables */
    const [calendarVisible, setCalendarVisible] = useState(false);
    const [calendarItemIndex, setCalendarItemIndex] = useState(null);
    const [calendarSelectedDate, setCalendarSelectedDate] = useState(null);

    const openCalendar = (index, currentDate) => {
        setCalendarItemIndex(index);
        setCalendarSelectedDate(currentDate || new Date().toISOString().split('T')[0]);
        setCalendarVisible(true);
    };

    const closeCalendar = () => {
        setCalendarVisible(false);
        setCalendarItemIndex(null);
        setCalendarSelectedDate(null);
    };

    const onCalendarDateChange = (newDate) => {
        if (calendarItemIndex !== null) {
            handleEditPress(calendarItemIndex, participantsData[calendarItemIndex], 'doa', newDate);
        }
        closeCalendar();
    };
    //#endregion

    //#region UseEffect
    useEffect(() => {
        setParticipantsData(data);
        setOriginalPartData(data);
        let options = trainings.map(training => ({
            value: training.trnUI,
            label: training.title
        }))
        setTRNOptions(options);
        getEmployeeId().then((res) => {
            if (res)
                setEmployeeid(res);
        }).catch((err) => {
            showMessage({
                message: t('common:loadError'),
                type: "danger",
                duration: 3000,
            });
        })
    }, [data, trainings]);
    //#endregion

    //#region Renderers
    const renderData = (item, index) => {
        return (
            <ParticipantsListView
                item={item}
                index={index}
                styles={styles}
                common={common}
                participantOptions={participantOptions}
                handleEditPress={handleEditPress}
                handleDelete={handleDelete}
                insertData={insertData}
                calendarSelectedDate={calendarSelectedDate}
                calendarVisible={calendarVisible && calendarItemIndex === index}
                openCalendar={() => openCalendar(index, item.doa)}
                onCalendarDateChange={onCalendarDateChange}
                equalCost={equalCost}
            />
        )
    }
    //#endregion

    //#region Handle Edit/Delete/New
    const handleEditPress = useCallback((index, item, key, value) => {
        if (item[key] === value) return;
        rowEdit(index, item, key, value, changes, setChanges, participantsData, setParticipantsData);
    }, []);

    const handleDelete = (item, index, attribute) => {
        rowDelete(item, index, attribute, changes, setChanges, participantsData, setParticipantsData, setDeletedItems, ref);
    };

    const handleAddNew = () => {
        let temp = [...participantsData];
        if (participantsData.length === 0) {
            temp = [{
                participants: "",
                isAccepted: false,
                dateAwarded: "",
                isFacilitator: false,
                firstEvaluation: false,
                secondEvaluation: false,
                cost: "",
                rowguid: "",
                trnUI: selectedTraining
            }];
        }
        rowAdd(temp, setParticipantsData, ['rowguid'], [], ref, t, [], [], undefined, undefined, insertData, setInsertData, 'rowguid');
    };

    /* useEffect to fix issue with adding 2 new lines whe non exist for now
     * TODO: fix issue and remove this part of the code
    */
    useEffect(() => {
        if (participantsData.length === 2) {
            const [obj1, obj2] = participantsData;

            // Check if one object has empty trnUI and the other has empty rowguid
            const condition1 = obj1.trnUI === '' && obj2.rowguid === '';
            const condition2 = obj2.trnUI === '' && obj1.rowguid === '';

            if (condition1 || condition2) {
                const combined = {
                    ...obj1,
                    ...obj2,
                    rowguid: obj1.rowguid || obj2.rowguid,
                    trnUI: obj1.trnUI || obj2.trnUI,
                };
                setParticipantsData([combined]);
            }
        }
    }, [participantsData]);
    //#endregion

    //#region Save
    const saveParticipants = async () => {
        if (Object.entries(changes).length === 0 && deletedItems.length === 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "warning",
                duration: 3000,
            });
            return;
        }

        setIsLoading(true);
        let dataForInsert = [];
        let dataForUpdate = [];

        Object.values(participantsData).forEach((item) => {
            if (insertData.includes(item.rowguid)) {
                dataForInsert.push(item);
            } else {
                dataForUpdate.push(item);
            }
        });

        dataForInsert.forEach(item => {
            item.trnUI = selectedTraining;
        });

        // Prepare promises array
        let promises = [];
        let insertSucc = true;
        let updateSucc = true;
        let deleteSucc = true;

        if (dataForUpdate.length > 0) {
            promises.push(
                saveParticipantsData(dataForUpdate)
                    .then(res => {
                        if (!res) updateSucc = false;
                        else removeFromChangesAfterSave(dataForUpdate);
                    })
                    .catch(() => { updateSucc = false; })
            );
        }

        if (dataForInsert.length > 0) {
            promises.push(
                saveParticipantsData(dataForInsert)
                    .then(res => {
                        if (!res) insertSucc = false;
                        else removeFromChangesAfterSave(dataForInsert);
                    })
                    .catch(() => { insertSucc = false; })
            );
        }

        if (deletedItems.length > 0) {
            promises.push(
                deleteParticipantsData(deletedItems)
                    .then(res => {
                        if (!res) deleteSucc = false;
                        else removeFromChangesAfterSave(deletedItems);
                    })
                    .catch(() => { deleteSucc = false; })
            );
        }

        try {
            await Promise.all(promises);
            setIsLoading(false);

            if (!insertSucc || !updateSucc || !deleteSucc) {
                if (!deleteSucc) {
                    showMessage({
                        message: t('common:errorSaving'),
                        type: "danger",
                        duration: 3000,
                    });
                    // Remove failed deletes from changes
                    let filteredChanges = Object.fromEntries(
                        Object.entries(changes).filter(([key, value]) => !deletedItems.includes(value.rowguid))
                    );
                    setChanges(filteredChanges);
                } else {
                    showMessage({
                        message: t('common:errorSaving'),
                        type: "danger",
                        duration: 3000,
                    });
                }
            } else {
                showMessage({
                    message: t('common:allOperationsSuccMess'),
                    type: "success",
                    duration: 3000,
                });
                setDuplicates([]);
                setRefreshAfterSave(true);
            }
        } catch (error) {
            setIsLoading(false);
            setRefreshAfterSave(true);
            setDuplicates([]);
        }
    };

    const AfterImport = () => {
        closeModal();
        setRefreshAfterSave(true);
    }

    const removeFromChangesAfterSave = (items) => {
        // Remove saved items from changes
        let updatedChanges = { ...changes };
        items.forEach(item => {
            if (item.rowguid && updatedChanges[item.rowguid]) {
                delete updatedChanges[item.rowguid];
            }
        });
        setChanges(updatedChanges);
        if (items.length > 0 && typeof items[0] === 'string') {
            setDeletedItems(prev => prev.filter(id => !items.includes(id)));
        }
    };
    //#endregion

    //#region DeleteAll
    const deleteAllParticipants = async () => {
        if (participantsData.length === 0) {
            showMessage({
                message: t('common:noParticipantsToDelete'),
                type: 'warning',
                duration: 3000,
            });
            return;
        }

        const deletePart = async () => {
            setIsLoading(true);
            try {
                const allRowGuids = participantsData.map(p => p.rowguid);
                const success = await deleteParticipantsData(allRowGuids);

                if (success) {
                    showMessage({
                        message: t('common:allParticipantsDeleted'),
                        type: 'success',
                        duration: 3000,
                    });

                    // Clear local states
                    removeFromChangesAfterSave(allRowGuids);
                    setParticipantsData([]);
                    setChanges({});
                    setDeletedItems([]);
                    setInsertData([]);
                    setDuplicates([]);
                    setRefreshAfterSave(true);
                } else {
                    showMessage({
                        message: t('common:errorDeletingParticipants'),
                        type: 'danger',
                        duration: 3000,
                    });
                }
            } catch (error) {
                showMessage({
                    message: t('common:errorDeletingParticipants'),
                    type: 'danger',
                    duration: 3000,
                });
            } finally {
                setIsLoading(false);
            }
        }

        if (!modalVisible) {
            Swal.fire({
                title: t('common:areusure'),
                text: t('common:deleteAllPartConfirmation'),
                icon: "question",
                showCancelButton: true,
                reverseButtons: true,
                cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                cancelButtonColor: '#d3d3d3',
                confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Delete</text>`,
                confirmButtonColor: '#A0A2FF',
            }).then((result) => {
                if (result.isConfirmed) {
                    deletePart();
                }
            });
        } else {
            deletePart();
        }
    };
    //#endregion

    //#region CopyPart
    const copyPart = () => {
        closeCopyModal();
        checkAuthParticipants(fromUI).then((res) => {
            if (!res) {
                Swal.fire({
                    title: t('common:areusure'),
                    text: "You do not have access to copy all participants of the selected training. Do you wish to proceed with only the participants available to you?",
                    icon: "question",
                    showCancelButton: true,
                    reverseButtons: true,
                    cancelButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Cancel</text>`,
                    cancelButtonColor: '#d3d3d3',
                    confirmButtonText: `<text style="font-family:'Roboto-Medium', font-size:16px">Copy</text>`,
                    confirmButtonColor: '#A0A2FF',
                }).then((result) => {
                    if (result.isConfirmed) {
                        setIsLoading(true)
                        copyParticipants(fromUI, selectedTraining).then((res) => {
                            if (res === 200) {
                                showMessage({
                                    message: t('common:copyPartSuccess'),
                                    type: "success",
                                    duration: 3000,
                                });
                                setRefreshAfterSave(true);
                            }
                            setIsLoading(false)
                        }).catch((error) => {
                            showMessage({
                                message: t('common:copyPartError'),
                                type: "danger",
                                duration: 3000,
                            })
                        })
                    }
                });
            } else {
                setIsLoading(true)
                copyParticipants(fromUI, selectedTraining).then((res) => {
                    if (res === 200) {
                        showMessage({
                            message: t('common:copyPartSuccess'),
                            type: "success",
                            duration: 3000,
                        });
                        setRefreshAfterSave(true);
                    }
                    setIsLoading(false)
                }).catch((error) => {
                    showMessage({
                        message: t('common:copyPartError'),
                        type: "danger",
                        duration: 3000,
                    })
                    setIsLoading(false)
                })

            }
        }).catch((error) => {
            showMessage({
                message: t('common:copyPartError'),
                type: "danger",
                duration: 3000,
            })
        })
    }

    //#region Print/Export
    const openLink = async (url) => {
        try {
            const supported = await Linking.canOpenURL(url);
            if (supported) {
                await Linking.openURL(url);
            } else {
                console.log("Don't know how to open UR");
            }
        } catch (err) {
            console.error("An error occurred", err);
        }
    };

    const print = async () => {
        setIsLoading(true);
        await printParticipants(selectedTraining)
            .then((res) => {
                if (res) {
                    openLink(res)
                    showMessage({
                        message: t("common:printTrnSuccess"),
                        type: "success",
                        duration: 3000,
                    });
                }
                setIsLoading(false);
            })
            .catch((error) => {
                setIsLoading(false);
                showMessage({
                    message: t("common:errorSave"),
                    type: "danger",
                    duration: 3000,
                });
            })
    }
    //#endregion

    //#region ExportToExcel
    const exportParticipantsToExcel = () => {
        if (!participantsData || participantsData.length === 0) {
            showMessage({
                message: t('common:noParticipantsToExport'),
                type: 'warning',
                duration: 3000,
            });
            return;
        }

        // Prepare data array for export
        const dataForExport = participantsData.map(p => ({
            Participant: p.participants || '',
            Accepted: p.isAccepted ? 'Yes' : 'No',
            DateAwarded: p.doa || '',
            Facilitator: p.isFacilitator ? 'Yes' : 'No',
            FirstEvaluation: p.firstEvaluation ? 'Yes' : 'No',
            SecondEvaluation: p.secondEvaluation ? 'Yes' : 'No',
            Cost: p.cost || '',
        }));

        // Create a new workbook and worksheet
        const wb = XLSX.utils.book_new();

        // Convert JSON data to worksheet
        const ws = XLSX.utils.json_to_sheet(dataForExport);

        // Append worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'Participants');

        // Write workbook to binary string
        const excelBinary = XLSX.write(wb, { type: 'binary', bookType: 'xlsx' });

        // Convert binary string to base64
        const base64Data = btoa(excelBinary);

        // Prepare item for download
        const item = {
            data: base64Data,
            name: 'ParticipantsData',
            type: 'xlsx',
        };

        // Download Excel file
        downloadExcelFile(item);

        showMessage({
            message: t('common:exportSuccess'),
            type: 'success',
            duration: 3000,
        });
    };

    const downloadExcelFile = useCallback(async (item) => {
        if (Platform.OS === 'web') {
            // Create a Blob from the base64 data
            const blobData = await fetch(`data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${item.data}`)
                .then(res => res.blob());

            // Create a download link element
            const url = URL.createObjectURL(blobData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${item.name}.${item.type}`);

            // Append the link to the document body
            document.body.appendChild(link);

            // Trigger the download by simulating click
            link.click();

            // Clean up by removing the link and revoking the object URL
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }, []);
    //#endregion

    //#region Loading
    if (isLoading)
        return (
            <View style={styles.loader}>
                <ActivityIndicator animating={true} color={colors.blue} />
            </View>
        )
    //#endregion

    return (
        <>
            <SafeAreaView style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 10, marginBottom: 10 }}>
                {/* Right side: Total participants label */}
                <SafeAreaView>
                    <CustomLabel
                        value={`${t('common:totalNumberOfParticipants')}: ${totalPart}`}
                        type="SUBTITLE"
                    />
                </SafeAreaView>
                {/* Left side: Buttons */}
                <SafeAreaView style={{ flexDirection: 'row', alignItems: 'center' }}>
                    <CustomButton
                        iconName="person-add-outline"
                        onPress={openModal}
                        tooltipText={"Import Participants"}
                        textTop='3'
                        type="PART"
                        show="PART"
                        sz={25}
                        style={{ marginRight: 8 }}
                    />
                    <CustomButton
                        iconName='copy-outline'
                        onPress={openCopyModal}
                        tooltipText={"Copy Participants"}
                        textTop='3'
                        type="PART"
                        show="PART"
                        sz={25}
                        style={{ marginRight: 8 }}
                    />
                    <CustomButton
                        iconName='trash-outline'
                        onPress={() => { deleteAllParticipants() }}
                        tooltipText={"Delete All Participants"}
                        textTop='3'
                        type="PART"
                        show="PART"
                        sz={25}
                        style={{ marginRight: 8 }}
                    />
                    <CustomButton
                        iconName='print-outline'
                        onPress={() => { print(); }}
                        tooltipText={"Print Participants"}
                        textTop='3'
                        type="PART"
                        show="PART"
                        sz={25}
                        style={{ marginRight: 8 }}
                    />
                    <CustomButton
                        iconName='download-outline'
                        onPress={exportParticipantsToExcel}
                        tooltipText={"Export participants to excel"}
                        textTop='3'
                        type="PART"
                        show="PART"
                        sz={25}
                    />
                </SafeAreaView>
            </SafeAreaView>
            <View style={[styles.buttons]}>
                <CustomButton
                    text={t('common:new')}
                    onPress={() => { handleAddNew() }}
                    type='BUTTON_ADD'
                    textTop='0'
                    sz={15}
                />
                {isEdit && <CustomButton
                    text={t('common:save')}
                    onPress={() => { saveParticipants() }}
                    type='BUTTON_SAVE'
                    textTop='0'
                    sz={15}
                    isGradient={true}
                />}
                <CustomButton
                    text={t('common:cancel')}
                    onPress={() => {
                        handleCancelChanges(setParticipantsData, originalPartData, setDeletedItems, setChanges);
                    }}
                    type="BUTTON_CANCEL"
                    textTop='0'
                    sz={15}
                />
            </View>
            <FlatList
                data={participantsData}
                keyExtractor={(item) => item.rowguid}
                scrollEnabled={true}
                ListHeaderComponent={
                    <SafeAreaView style={common.listTitle}>
                        <SafeAreaView style={[styles.rowHeaders]}>
                            {participantsTabData && Object.entries(participantsTabData).map(([key, field]) => {
                                if (field.isVisible === false) return null;
                                const types = Array.isArray(field.type) ? field.type : [field.type];
                                const isCheckbox = types.includes('checkbox') || types.includes('input');
                                return (
                                    <SafeAreaView
                                        key={key}
                                        style={isCheckbox ? styles.checkboxColumn : styles.inputColumn}
                                    >
                                        <CustomLabel
                                            value={t(`common:${key}`)}
                                            type="SUBTITLE"
                                        />
                                    </SafeAreaView>
                                );
                            })}
                        </SafeAreaView>
                        <SafeAreaView style={common.divider} />
                    </SafeAreaView>
                }
                renderItem={({ item, index }) => renderData(item, index)}
                initialNumToRender={4}
            />
            {/* Modal To add Participants */}
            <Modal
                animationType="slide"
                transparent={true}
                visible={modalVisible}
                onRequestClose={closeModal}
                onBackdropPress={closeModal}
            >
                <SafeAreaView style={styles.modalOverlay}>
                    <SafeAreaView style={styles.modalContainer}>
                        <SafeAreaView style={{ padding: 20 }}>
                            <CustomLabel value="Add Active Employees" type="TITLE" style={{ textAlign: 'left', margin: 10 }} />
                        </SafeAreaView>

                        <SafeAreaView style={{ paddingHorizontal: 20 }}>
                            {errorMessage ? (
                                <View style={styles.errorMessageContainer}>
                                    <Text style={styles.errorMessageText}>{errorMessage}</Text>
                                </View>
                            ) : null}
                        </SafeAreaView>

                        <ScrollView>
                            <HRAdminAuthorizationForm
                                employee={{ username: username, employeeID: employeeID }}
                                isTrnParticipants={true}
                                setErrorMessage={setErrorMessage}
                                selectedTraining={selectedTraining}
                                deleteAllParticipants={deleteAllParticipants}
                                removeFromChangesAfterSave={removeFromChangesAfterSave}
                                saveParticipantsData={saveParticipantsData}
                                AfterImport={AfterImport}
                                rules={rules}
                                setRules={setRules}
                            />
                        </ScrollView>
                        <CustomButton text="Cancel" onPress={closeModal} type="BUTTON_CANCEL" />
                    </SafeAreaView>
                </SafeAreaView>
            </Modal>
            {/* Modal To copy Participants */}
            <Modal
                animationType="slide"
                transparent={true}
                visible={copyModalVisible}
                onRequestClose={closeCopyModal}
                onBackdropPress={closeCopyModal}
            >
                <SafeAreaView style={styles.modalOverlay}>
                    <SafeAreaView style={styles.modalContainer}>
                        <SafeAreaView style={{ padding: 20 }}>
                            <CustomLabel value="Copy Participants" type="TITLE" style={{ textAlign: 'left', margin: 10 }} />
                        </SafeAreaView>

                        <SafeAreaView style={{ paddingHorizontal: 20 }}>
                            {errorMessage ? (
                                <View style={styles.errorMessageContainer}>
                                    <Text style={styles.errorMessageText}>{errorMessage}</Text>
                                </View>
                            ) : null}
                        </SafeAreaView>

                        <ScrollView style={{ flexDirection: 'row', padding: 20 }}>
                            <CustomLabel
                                value={"Copy Participants From" + ":"}
                                type='EDIT_EMPLOYEE_HEADER'
                            />
                            <CustomDropDown
                                type="EDIT_EMPLOYEE"
                                options={trnOptions}
                                setValue={(val) => { setFromUI(val) }}
                                value={fromUI}
                                defValue={fromUI}
                            />
                        </ScrollView>
                        <SafeAreaView style={{ flexDirection: 'row', justifyContent: "center" }}>
                            <CustomButton text="Copy" onPress={copyPart} type="BUTTON_SAVE" isGradient={true} />
                            <CustomButton text="Cancel" onPress={closeCopyModal} type="BUTTON_CANCEL" />
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>

            </Modal>
        </>
    );
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    modalOverlay: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.5)',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20,
    },
    modalContainer: {
        maxWidth: '95%',
        maxHeight: '90%',
        backgroundColor: 'white',
        borderRadius: 10,
        padding: 20,
    },
    errorMessageContainer: {
        backgroundColor: colors.background,
        padding: 10,
        borderRadius: 5,
        marginVertical: 10,
    },
    errorMessageText: {
        color: colors.validation_error,
        fontWeight: 'bold',
    },
    row: {
        flex: 1,
        flexDirection: "row",
        alignItems: 'center',
        paddingHorizontal: 5,
        justifyContent: 'space-around',
    },
    column: {
        width: '40%',
        height: '100%',
        marginBottom: 10
    },
    verticalLine: {
        backgroundColor: colors.background_gray,
        width: 3,
        height: '100%',
        marginHorizontal: '2%'
    },
    box: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginTop: 5,
        flex: 1
    },
    icons: {
        fontSize: 25,
        color: colors.text_primary,
        margin: '5%'
    },
    label: {
        flex: 1,
        textAlign: 'left',
    },
    input: {
        flex: 1,
        marginVertical: '2%'
    },
    rowHeaders: {
        flexDirection: "row",
        marginHorizontal: '1%',
    },
    verticalline: {
        backgroundColor: colors.buttons_primary,
        height: '100%',
        width: 1,
    },
    checkboxColumn: {
        width: '12%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    lastColumn: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        maxWidth: '12%'
    },
    inputColumn: {
        flex: 1,
        minWidth: '18%',
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        width: '50%',
        alignSelf: 'flex-end',
        zIndex: -1
    },
});
//#endregion

export default HRAdminTrainingParticipantsScreen;